import { Stream } from '@engoo/realtime-protocol/stream';
import { navigatorActionHandler, navigatorReducer, NavigatorState } from 'app/models/navigator/reducer';
import { tFunctionType } from 'app/services/localization';
import { LWWDocumentManager, IActionHandler } from 'app/services/rtc/sync/documentmanagers/lww';
import { IDocumentSpec } from 'app/services/rtc/sync/DocumentSpec';
import { INavigatorAction } from '@engoo/realtime-protocol/navigator';

export const INIT_ACTION_TYPE = Symbol('init');

export const SyncNavigatorDocumentSpec: IDocumentSpec<
  NavigatorState,
  INavigatorAction,
  IActionHandler<NavigatorState, INavigatorAction>,
  LWWDocumentManager<NavigatorState, INavigatorAction>
> = {
  managerType:   LWWDocumentManager,
  actionHandler: navigatorActionHandler,
  initialState:  navigatorReducer(),
  name: (t: tFunctionType) => t('rtc.features.synced-navigation.name'),
};

export default {
  [Stream.Navigator]: SyncNavigatorDocumentSpec,
};
